var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConditionIcon = function SvgConditionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 50,
    fill: "none",
    viewBox: "0 0 52 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f4dc6a",
    d: "m51.6 24.988-5.679 6.47.792 8.565-8.402 1.908-4.398 7.4L26 45.935l-7.913 3.42-4.398-7.4-8.402-1.908.791-8.588L.4 24.988l5.678-6.493-.79-8.564 8.4-1.885 4.4-7.401L26 4.043 33.913.645l4.398 7.4 8.402 1.91-.792 8.564zm-6.214 0-4.259-4.91.559-6.493-6.377-1.397-3.305-5.655L26 9.116l-6.004-2.583-3.305 5.655-6.377 1.373.559 6.494-4.26 4.933 4.26 4.888-.559 6.516 6.377 1.396 3.305 5.656L26 40.837l6.004 2.583 3.305-5.632 6.377-1.42-.559-6.492zM23.673 31.97h4.654v4.655h-4.654zm0-18.618h4.654v13.964h-4.654z"
  })));
};
export default SvgConditionIcon;